import {
  Subscription,
  SubscriptionPackageType,
  SubscriptionStatus,
} from 'services/programming'
import { MyAffiliate, Role } from 'types'

export function canAccessDashboard(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }

  return false
}

export function canAccessProgramming(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }

  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Coach, Role.Manager].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    ) != null
  ) {
    return true
  }

  return false
}

export function canAccessPlaybook(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }

  return false
}

export function canAccessPartnerNetwork(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager].some((r) => affiliate?.roles?.includes(r)),
    )
  ) {
    return true
  }

  return false
}

export function canAccessRoundtables(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        affiliate?.roles?.includes(Role.LOR),
    )
  ) {
    return true
  }

  return false
}

export function canAccessAffiliateStarterKit(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        affiliate?.roles?.includes(Role.LOR),
    )
  ) {
    return true
  }

  return false
}

export function canAccessTeammates(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    affiliate != null &&
    [Role.LOR, Role.Manager, Role.Coach].some((r) =>
      affiliate?.roles?.includes(r),
    ) &&
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId == affiliate?.groupId,
    )
  ) {
    return true
  }

  return false
}

export function canAccessContentKit(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }

  return false
}

export function canAccessSubscriptions(
  affiliate: MyAffiliate,
  allSubscriptions: Subscription[],
) {
  if (allSubscriptions === null && affiliate === null) {
    return null
  }
  if (
    affiliate != null &&
    [Role.LOR, Role.Manager].some((r) => affiliate?.roles?.includes(r)) &&
    allSubscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId == affiliate?.groupId &&
        s.status === SubscriptionStatus.active,
    ) &&
    allSubscriptions.find((r) => r.package.name === SubscriptionPackageType.CAP)
  ) {
    return true
  }

  return false
}

export function canAccessAdmin(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }

  return false
}

export function canAccessAdminDirectoryPage(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager].some((r) => affiliate?.roles?.includes(r)),
    )
  ) {
    return true
  }
}

export function canAccessAdminContactInfoPage(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager].some((r) => affiliate?.roles?.includes(r)),
    )
  ) {
    return true
  }
}

export function canAccessAdminBillingAndInvoices(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        affiliate?.roles?.includes(Role.LOR),
    )
  ) {
    return true
  }
}

export function canAccessAdminCoachesAndStaffPage(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }
}

export function canAccessAdminHelpPage(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }
}

export function canAccessAdminContactUsPage(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager, Role.Coach].some((r) =>
          affiliate?.roles?.includes(r),
        ),
    )
  ) {
    return true
  }
}

export function canAccessPricing(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }
  if (
    subscriptions?.find(
      (s) => s.package.name === SubscriptionPackageType.ATK_STARTER,
    )
  ) {
    return true
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager].some((r) => affiliate?.roles?.includes(r)),
    )
  ) {
    return true
  }

  return false
}

export function canInvite(
  affiliate: MyAffiliate,
  subscriptions: Subscription[],
) {
  if (subscriptions === null && affiliate === null) {
    return null
  }

  if (
    subscriptions?.find(
      (s) =>
        s.package.name === SubscriptionPackageType.ATK &&
        s.subscriberGroupId === affiliate?.groupId &&
        [Role.LOR, Role.Manager].some((r) => affiliate?.roles?.includes(r)),
    )
  ) {
    return true
  }

  return false
}
